<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  components: { Layout },

  data() {
    return {
      plan_idtype: 1,
      truckAtual: [],
      truckAnteriores: [],
      consultoresAtual: [],
      consultoresAnteriores: [],
      consultoresExpanded: [],
      unificacao: {
        loading: false,
        submitting: false,
        enabled: false,
        showSelection: false,
        message: "",
        eligibleIds: [],
        selectedIds: [],
      },
      solicitacaoLoadingIds: [],
      decisaoLoadingIds: [],
    };
  },

  computed: {
    truckAnterioresFiltrados() {
      return (this.truckAnteriores || []).filter((item) => {
        const mes = Number(item.mes);
        const ano = Number(item.ano);

        return ano > 2025 || (ano === 2025 && mes >= 7);
      });
    },

    consultoresAgrupados() {
      const grouped = {};
      [...this.consultoresAtual, ...this.consultoresAnteriores].forEach((item) => {
        const key = String(item.id_consultor);
        if (!grouped[key]) {
          grouped[key] = {
            id_consultor: item.id_consultor,
            per_name: item.per_name,
            months: [],
            resumo: {
              total: 0,
              aguardando: 0,
              aprovado: 0,
              diferenca: 0,
            },
          };
        }

        grouped[key].months.push(item);
        grouped[key].resumo.total += Number(item.total_producao || 0);
        grouped[key].resumo.aguardando += Number(item.aguardando || 0);
        grouped[key].resumo.aprovado += Number(item.aprovado || 0);
        grouped[key].resumo.diferenca += Number(item.diferenca || 0);
      });

      return Object.values(grouped)
        .map((group) => ({
          ...group,
          months: group.months
            .filter((item) => {
              const mes = Number(item.mes);
              const ano = Number(item.ano);
              return ano > 2025 || (ano === 2025 && mes >= 7);
            })
            .sort((a, b) => {
              const periodA = Number(a.ano) * 100 + Number(a.mes);
              const periodB = Number(b.ano) * 100 + Number(b.mes);
              return periodB - periodA;
            }),
        }))
        .filter((group) => group.months.length)
        .sort((a, b) => a.per_name.localeCompare(b.per_name, "pt-BR"));
    },
  },

  mounted() {
    this.loadTruck();
    this.loadConsultores();
    this.loadUnificacaoOptions();
  },

  methods: {
    loadTruck() {
      api.get("notasfiscais/producoestruck/v2").then((res) => {
        if (res.data.status === "success") {
          this.plan_idtype = res.data.plan_idtype || 1;
          this.truckAtual = (res.data.atual || []).map(this.normalizarCard);
          this.truckAnteriores = (res.data.anteriores || []).map(this.normalizarCard);
        }
      });
    },

    loadConsultores() {
      api.get("notasfiscais/producoesconsultores/truck/v2").then((res) => {
        if (res.data.status === "success") {
          this.consultoresAtual = (res.data.atual || []).map(this.normalizarCard);
          this.consultoresAnteriores = (res.data.anteriores || []).map(this.normalizarCard);
        }
      });
    },

    // Card conciliado sem NF propria na linha: o valor foi transferido para a
    // Regional (solicitacao aprovada) ou, antes dessa regra, a Regional enviou a
    // nota pelo consultor. A API devolve aprovado 0 e diferenca = total, o que
    // parecia saldo disponivel; aqui o card passa a refletir que foi quitado.
    normalizarCard(item) {
      const total = Number(item.total_producao || 0);
      const aprovado = Number(item.aprovado || 0);

      if (String(item.status) !== "concilied" || aprovado >= total) {
        return item;
      }

      return {
        ...item,
        aprovado: total,
        diferenca: 0,
        conciliado_pela_regional: true,
      };
    },

    refreshPageData() {
      this.loadTruck();
      this.loadUnificacaoOptions();
      if (this.plan_idtype === 2) {
        this.loadConsultores();
      }
    },

    loadUnificacaoOptions() {
      this.unificacao.loading = true;

      api
        .get("vitalicio/truck/unificar-valores/opcoes")
        .then((res) => {
          if (res.data.status === "success") {
            const payload = res.data.data || {};
            const options = payload.options || [];

            this.unificacao.enabled = !!payload.can_unify;
            this.unificacao.message = payload.message || "";
            this.unificacao.eligibleIds = options.map((item) =>
              String(item.line_id || item.id)
            );
            this.unificacao.selectedIds = [];
            return;
          }

          this.unificacao.enabled = false;
          this.unificacao.message =
            res.data.message || "Nenhum valor disponivel para unificacao.";
          this.unificacao.eligibleIds = [];
          this.unificacao.selectedIds = [];
          this.unificacao.showSelection = false;
        })
        .catch(() => {
          this.unificacao.enabled = false;
          this.unificacao.message =
            "Nao foi possivel carregar as opcoes de unificacao.";
          this.unificacao.eligibleIds = [];
          this.unificacao.selectedIds = [];
          this.unificacao.showSelection = false;
        })
        .finally(() => {
          this.unificacao.loading = false;
        });
    },

    abrirMesTruck(item) {
      if (!item.liberado) {
        this.$toast.error(
          "Mes selecionado esta bloqueado para importacao de NFs."
        );
        return;
      }

      this.$router.push({
        name: "MesNotasTruck",
        params: {
          sistema: "truck",
          mes: String(item.mes),
          ano: String(item.ano),
          line_id: String(item.line_id),
        },
      });
    },

    toggleConsultor(idConsultor) {
      const id = String(idConsultor);
      if (this.consultoresExpanded.includes(id)) {
        this.consultoresExpanded = this.consultoresExpanded.filter((item) => item !== id);
        return;
      }

      this.consultoresExpanded = [...this.consultoresExpanded, id];
    },

    consultorExpanded(idConsultor) {
      return this.consultoresExpanded.includes(String(idConsultor));
    },

    toggleUnificacao() {
      if (!this.unificacao.enabled || !this.unificacao.eligibleIds.length) {
        if (this.unificacao.message) {
          this.$toast.error(this.unificacao.message);
        }
        return;
      }

      this.unificacao.showSelection = !this.unificacao.showSelection;

      if (!this.unificacao.showSelection) {
        this.unificacao.selectedIds = [];
      }
    },

    isTruckElegivelUnificacao(item) {
      return (
        ["divergence", "pending_nfs"].includes(String(item.status)) &&
        this.unificacao.eligibleIds.includes(String(item.line_id))
      );
    },

    handleTruckAnteriorClick(item) {
      if (this.unificacao.showSelection && this.isTruckElegivelUnificacao(item)) {
        this.toggleTruckItem(item.line_id);
        return;
      }

      this.abrirMesTruck(item);
    },

    toggleTruckItem(lineId) {
      const id = String(lineId);
      const selected = [...this.unificacao.selectedIds];
      const index = selected.indexOf(id);

      if (index >= 0) {
        selected.splice(index, 1);
      } else {
        selected.push(id);
      }

      this.unificacao.selectedIds = selected;
    },

    confirmarUnificacao() {
      if (!this.unificacao.selectedIds.length) {
        this.$toast.error("Selecione ao menos um saldo para unificar.");
        return;
      }

      this.unificacao.submitting = true;

      api
        .post("vitalicio/truck/unificar-valores", {
          ids: this.unificacao.selectedIds,
        })
        .then((res) => {
          if (res.data.status === "success") {
            this.$toast.success(
              res.data.message || "Valores unificados com sucesso."
            );
            this.unificacao.showSelection = false;
            this.unificacao.selectedIds = [];
            this.refreshPageData();
            return;
          }

          this.$toast.error(
            res.data.message || "Nao foi possivel unificar os valores."
          );
        })
        .catch((err) => {
          // A API responde 400 com o motivo em message; sem isso o usuário só via a mensagem genérica.
          const msg = err && err.response && err.response.data && err.response.data.message;
          this.$toast.error(msg || "Nao foi possivel unificar os valores.");
        })
        .finally(() => {
          this.unificacao.submitting = false;
        });
    },

    totalSelecionadoUnificacao() {
      return (this.truckAnterioresFiltrados || []).reduce((total, item) => {
        if (!this.unificacao.selectedIds.includes(String(item.line_id))) {
          return total;
        }

        return total + Number(item.diferenca || 0);
      }, 0);
    },

    moeda(v) {
      return Number(v || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    statusLabel(status) {
      const map = {
        pending_nfs: "AGUARDANDO ENVIO",
        pending_conf: "AGUARDANDO CONFERENCIA",
        divergence: "SALDO DISPONIVEL",
        concilied: "CONCILIADO",
      };
      return map[status] || status;
    },

    // Antes isto devolvia um hex aplicado via :style com texto branco por
    // cima: #C49A00 dava 2,63:1, #228B22 dava 4,39:1 e o cinza padrao #999
    // dava 2,85:1 — todos abaixo do AA de 4,5:1 para texto pequeno.
    // Agora devolve a CLASSE do badge "soft" (fundo claro + texto escuro),
    // que usa os tokens --st-status-* definidos em design/custom/_tokens.scss.
    statusClass(status) {
      const map = {
        pending_nfs: "nf-status-pending",
        pending_conf: "nf-status-returned",
        divergence: "nf-status-pending",
        concilied: "nf-status-approved",
      };
      return map[status] || "nf-status-neutral";
    },

    requestStatusLabel(request) {
      if (!request) return "Sem solicitacao";

      const map = {
        pending: "Aguardando resposta",
        approved: "Aprovado",
        reproved: "Reprovado",
      };

      return map[request.status] || request.status;
    },

    // Mesma troca de hex por classe do statusClass() acima.
    requestStatusClass(request) {
      if (!request) return "nf-status-neutral";

      const map = {
        pending: "nf-status-pending",
        approved: "nf-status-approved",
        reproved: "nf-status-rejected",
      };

      return map[request.status] || "nf-status-neutral";
    },

    requestDescription(item) {
      if (!item.request) {
        return "Nenhuma solicitacao registrada.";
      }

      if (item.request.status === "pending") {
        return `${item.request.regional_name || "Regional"} solicitou a unificacao deste valor.`;
      }

      if (item.request.status === "approved") {
        return `${item.request.regional_name || "Regional"} solicitou a unificacao deste valor e o consultor aprovou.`;
      }

      return `${item.request.regional_name || "Regional"} solicitou a unificacao deste valor e o consultor reprovou.`;
    },

    // Coluna Solicitacao quando nao ha pendencia. A unificacao (item.unificacao,
    // vinda da API) tem prioridade: ela diz para onde foi o saldo que zerou o card —
    // para a Regional (transferencia aprovada) ou para o proprio consultor
    // ("Unificar Valores").
    hasRequestResolvido(item) {
      return (
        !!item.unificacao ||
        (item.request && item.request.status !== "pending") ||
        item.conciliado_pela_regional
      );
    },

    requestResolvidoLabel(item) {
      if (item.unificacao) {
        return item.unificacao.destino === "regional" ? "Aprovado" : "Unificado";
      }
      return item.request ? this.requestStatusLabel(item.request) : "Aprovado";
    },

    requestResolvidoClass(item) {
      if (item.unificacao) return "nf-status-approved";
      return item.request
        ? this.requestStatusClass(item.request)
        : "nf-status-approved";
    },

    requestResolvidoDescription(item) {
      const u = item.unificacao;
      if (u) {
        const periodo = `${u.mes}/${u.ano}`;
        return u.destino === "regional"
          ? `${this.moeda(u.valor)} transferido para ${u.nome_destino || "a Regional"} em ${periodo}.`
          : `${this.moeda(u.valor)} unificado no card de ${periodo}.`;
      }
      return item.request
        ? this.requestDescription(item)
        : "Nota fiscal enviada pela Regional.";
    },

    hasPendingRequest(item) {
      return item.request && item.request.status === "pending";
    },

    canSolicitarUnificacao(item) {
      return (
        this.plan_idtype === 2 &&
        Number(item.diferenca || 0) > 0 &&
        ["pending_nfs", "divergence"].includes(String(item.status)) &&
        (!item.request || item.request.status !== "pending")
      );
    },

    isSolicitando(lineId) {
      return this.solicitacaoLoadingIds.includes(String(lineId));
    },

    isDecidindo(requestId) {
      return this.decisaoLoadingIds.includes(String(requestId));
    },

    async solicitarUnificacaoConsultor(item) {
      const lineId = String(item.line_id);
      this.solicitacaoLoadingIds = [...this.solicitacaoLoadingIds, lineId];

      try {
        const res = await api.post("notasfiscais/unificacao/solicitar/truck", {
          id_consultor: item.id_consultor,
          line_id: item.line_id,
        });

        if (res.data.status === "success") {
          this.$toast.success(res.data.message || "Solicitacao enviada.");
          this.loadConsultores();
          return;
        }

        this.$toast.error(res.data.message || "Nao foi possivel solicitar.");
      } catch (e) {
        this.$toast.error("Nao foi possivel solicitar a unificacao.");
      } finally {
        this.solicitacaoLoadingIds = this.solicitacaoLoadingIds.filter(
          (id) => id !== lineId
        );
      }
    },

    async aprovarSolicitacao(item) {
      const requestId = String(item.request.request_id);
      this.decisaoLoadingIds = [...this.decisaoLoadingIds, requestId];

      try {
        const res = await api.post("notasfiscais/unificacao/aprovar/truck", {
          request_id: item.request.request_id,
        });

        if (res.data.status === "success") {
          this.$toast.success(res.data.message || "Solicitacao aprovada.");
          this.refreshPageData();
          return;
        }

        this.$toast.error(res.data.message || "Nao foi possivel aprovar.");
      } catch (e) {
        this.$toast.error(
          e?.response?.data?.message || "Nao foi possivel aprovar a solicitacao."
        );
      } finally {
        this.decisaoLoadingIds = this.decisaoLoadingIds.filter(
          (id) => id !== requestId
        );
      }
    },

    async reprovarSolicitacao(item) {
      const requestId = String(item.request.request_id);
      this.decisaoLoadingIds = [...this.decisaoLoadingIds, requestId];

      try {
        const res = await api.post("notasfiscais/unificacao/reprovar/truck", {
          request_id: item.request.request_id,
        });

        if (res.data.status === "success") {
          this.$toast.success(res.data.message || "Solicitacao reprovada.");
          this.refreshPageData();
          return;
        }

        this.$toast.error(res.data.message || "Nao foi possivel reprovar.");
      } catch (e) {
        this.$toast.error("Nao foi possivel reprovar a solicitacao.");
      } finally {
        this.decisaoLoadingIds = this.decisaoLoadingIds.filter(
          (id) => id !== requestId
        );
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="page-title-box mb-4">
      <h3>Producoes APVS Truck</h3>
      <p>Selecione o mes de producao para envio das suas notas fiscais</p>
    </div>

    <h5 class="mb-3">Mes Atual</h5>

    <div class="card mb-4">
      <div class="card-header bg-primary text-white text-center">
        APVS Truck
      </div>

      <div class="card-body">
        <div class="d-flex justify-content-end mb-3">
          <button
            class="btn btn-primary"
            :disabled="unificacao.loading"
            @click="toggleUnificacao"
          >
            {{ unificacao.showSelection ? "Cancelar" : "Unificar Valores" }}
          </button>
        </div>

        <div
          v-for="item in truckAtual"
          :key="'ta-' + item.line_id"
          class="finance-card mb-3"
          :class="item.liberado ? 'finance-card-clickable' : 'finance-card-locked'"
          @click="abrirMesTruck(item)"
        >
          <div class="finance-grid">
            <div class="finance-field">
              <span class="finance-label">Mes/Ano</span>
              <span>{{ item.mes }}/{{ item.ano }}</span>
            </div>
            <div class="finance-field">
              <span class="finance-label">Total</span>
              <span>{{ moeda(item.total_producao) }}</span>
            </div>
            <div class="finance-field">
              <span class="finance-label">Aguardando</span>
              <span>{{ moeda(item.aguardando) }}</span>
            </div>
            <div class="finance-field">
              <span class="finance-label">Aprovado</span>
              <span>{{ moeda(item.aprovado) }}</span>
            </div>
            <div class="finance-field">
              <span class="finance-label">Diferenca</span>
              <span>{{ moeda(item.diferenca) }}</span>
            </div>
            <div class="finance-field">
              <span class="finance-label">Status NF</span>
              <span
                class="badge px-3 py-2"
                :class="statusClass(item.status)"
              >
                {{ statusLabel(item.status) }}
              </span>
            </div>
            <div v-if="plan_idtype === 1" class="finance-field" @click.stop>
              <span class="finance-label">Solicitacao</span>
              <div v-if="hasPendingRequest(item)" class="request-box">
                <div class="request-text">{{ requestDescription(item) }}</div>
                <div class="request-actions">
                  <button
                    class="btn btn-success btn-sm"
                    :disabled="isDecidindo(item.request.request_id)"
                    @click.stop="aprovarSolicitacao(item)"
                  >
                    Aprovar
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    :disabled="isDecidindo(item.request.request_id)"
                    @click.stop="reprovarSolicitacao(item)"
                  >
                    Reprovar
                  </button>
                </div>
              </div>
              <div v-else-if="hasRequestResolvido(item)" class="request-status">
                <span
                  class="badge px-3 py-2"
                  :class="requestResolvidoClass(item)"
                >
                  {{ requestResolvidoLabel(item) }}
                </span>
                <small class="request-help">{{ requestResolvidoDescription(item) }}</small>
              </div>
              <span v-else>-</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h5 class="mb-3">Meses Anteriores</h5>

    <div class="card mb-4">
      <div class="card-header bg-primary text-white text-center">
        APVS Truck
      </div>

      <div class="card-body">
        <div
          v-for="item in truckAnterioresFiltrados"
          :key="'tp-' + item.line_id"
          class="finance-card mb-3"
          :class="item.liberado ? 'finance-card-clickable' : 'finance-card-locked'"
          @click="handleTruckAnteriorClick(item)"
        >
          <div class="finance-grid">
            <div
              v-if="unificacao.showSelection"
              class="finance-field finance-field-checkbox"
              @click.stop
            >
              <span class="finance-label">Selecionar</span>
              <input
                v-if="isTruckElegivelUnificacao(item)"
                v-model="unificacao.selectedIds"
                type="checkbox"
                :value="String(item.line_id)"
                @click.stop
                @change.stop
              />
              <span v-else>-</span>
            </div>
            <div class="finance-field">
              <span class="finance-label">Mes/Ano</span>
              <span>{{ item.mes }}/{{ item.ano }}</span>
            </div>
            <div class="finance-field">
              <span class="finance-label">Total</span>
              <span>{{ moeda(item.total_producao) }}</span>
            </div>
            <div class="finance-field">
              <span class="finance-label">Aguardando</span>
              <span>{{ moeda(item.aguardando) }}</span>
            </div>
            <div class="finance-field">
              <span class="finance-label">Aprovado</span>
              <span>{{ moeda(item.aprovado) }}</span>
            </div>
            <div class="finance-field">
              <span class="finance-label">Diferenca</span>
              <span>{{ moeda(item.diferenca) }}</span>
            </div>
            <div class="finance-field">
              <span class="finance-label">Status NF</span>
              <span
                class="badge px-3 py-2"
                :class="statusClass(item.status)"
              >
                {{ statusLabel(item.status) }}
              </span>
            </div>
            <div v-if="plan_idtype === 1" class="finance-field" @click.stop>
              <span class="finance-label">Solicitacao</span>
              <div v-if="hasPendingRequest(item)" class="request-box">
                <div class="request-text">{{ requestDescription(item) }}</div>
                <div class="request-actions">
                  <button
                    class="btn btn-success btn-sm"
                    :disabled="isDecidindo(item.request.request_id)"
                    @click.stop="aprovarSolicitacao(item)"
                  >
                    Aprovar
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    :disabled="isDecidindo(item.request.request_id)"
                    @click.stop="reprovarSolicitacao(item)"
                  >
                    Reprovar
                  </button>
                </div>
              </div>
              <div v-else-if="hasRequestResolvido(item)" class="request-status">
                <span
                  class="badge px-3 py-2"
                  :class="requestResolvidoClass(item)"
                >
                  {{ requestResolvidoLabel(item) }}
                </span>
                <small class="request-help">{{ requestResolvidoDescription(item) }}</small>
              </div>
              <span v-else>-</span>
            </div>
          </div>
        </div>

        <div
          v-if="unificacao.showSelection"
          class="d-flex justify-content-between align-items-center mt-3 flex-wrap"
        >
          <div class="font-weight-bold mb-2 mb-md-0">
            {{ unificacao.selectedIds.length }} selecionado(s) |
            {{ moeda(totalSelecionadoUnificacao()) }}
          </div>

          <button
            class="btn btn-success"
            :disabled="!unificacao.selectedIds.length || unificacao.submitting"
            @click="confirmarUnificacao"
          >
            {{ unificacao.submitting ? "Confirmando..." : "Confirmar" }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="plan_idtype === 2" class="mb-4">
      <h5 class="mb-3">Consultores</h5>

      <div
        v-for="group in consultoresAgrupados"
        :key="'consultor-' + group.id_consultor"
        class="consultor-group card mb-3"
      >
        <div
          class="card-header consultor-header"
          @click="toggleConsultor(group.id_consultor)"
        >
          <div>
            <div class="consultor-name">{{ group.per_name }}</div>
            <div class="consultor-subtitle">
              {{ group.months.length }} card(s) de producao
            </div>
          </div>
          <button class="btn btn-outline-primary btn-sm" type="button">
            {{ consultorExpanded(group.id_consultor) ? "Ocultar" : "Visualizar" }}
          </button>
        </div>

        <div class="card-body">
          <div class="consultor-summary-grid">
            <div class="summary-box">
              <span class="finance-label">Total</span>
              <strong>{{ moeda(group.resumo.total) }}</strong>
            </div>
            <div class="summary-box">
              <span class="finance-label">Aguardando</span>
              <strong>{{ moeda(group.resumo.aguardando) }}</strong>
            </div>
            <div class="summary-box">
              <span class="finance-label">Aprovado</span>
              <strong>{{ moeda(group.resumo.aprovado) }}</strong>
            </div>
            <div class="summary-box">
              <span class="finance-label">Diferenca</span>
              <strong>{{ moeda(group.resumo.diferenca) }}</strong>
            </div>
          </div>

          <div v-if="consultorExpanded(group.id_consultor)" class="mt-3">
            <div
              v-for="item in group.months"
              :key="'consultor-month-' + item.line_id"
              class="finance-card finance-card-static mb-3"
            >
              <div class="finance-grid">
                <div class="finance-field">
                  <span class="finance-label">Mes/Ano</span>
                  <span>{{ item.mes }}/{{ item.ano }}</span>
                </div>
                <div class="finance-field">
                  <span class="finance-label">Total</span>
                  <span>{{ moeda(item.total_producao) }}</span>
                </div>
                <div class="finance-field">
                  <span class="finance-label">Aguardando</span>
                  <span>{{ moeda(item.aguardando) }}</span>
                </div>
                <div class="finance-field">
                  <span class="finance-label">Aprovado</span>
                  <span>{{ moeda(item.aprovado) }}</span>
                </div>
                <div class="finance-field">
                  <span class="finance-label">Diferenca</span>
                  <span>{{ moeda(item.diferenca) }}</span>
                </div>
                <div class="finance-field">
                  <span class="finance-label">Status NF</span>
                  <span
                    class="badge px-3 py-2"
                    :class="statusClass(item.status)"
                  >
                    {{ statusLabel(item.status) }}
                  </span>
                </div>
                <div class="finance-field">
                  <span class="finance-label">Solicitacao</span>
                  <div
                    v-if="item.unificacao || (item.request && item.request.status !== 'reproved')"
                    class="request-status"
                  >
                    <span
                      class="badge px-3 py-2"
                      :class="requestResolvidoClass(item)"
                    >
                      {{ requestResolvidoLabel(item) }}
                    </span>
                    <small class="request-help">{{ requestResolvidoDescription(item) }}</small>
                  </div>
                  <button
                    v-else
                    class="btn btn-primary btn-sm"
                    :disabled="
                      !canSolicitarUnificacao(item) || isSolicitando(item.line_id)
                    "
                    @click="solicitarUnificacaoConsultor(item)"
                  >
                    Solicitar Unificacao
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.finance-card {
  border: 1px solid var(--st-border-soft);
  border-radius: var(--st-radius-lg);
  padding: 16px;
  background: var(--st-surface);
}

.finance-card-clickable {
  cursor: pointer;
}

.finance-card-clickable:hover {
  transform: translateY(-2px);
  transition: 0.15s ease;
  box-shadow: var(--st-shadow-md);
}

.finance-card-locked {
  cursor: not-allowed;
}

.finance-card-static {
  cursor: default;
}

.finance-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 14px;
  align-items: start;
}

.finance-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.finance-field-checkbox {
  align-items: flex-start;
}

.finance-label {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--st-text-muted);
  letter-spacing: 0.04em;
}

.consultor-group {
  border: 1px solid var(--st-border-soft);
  border-radius: var(--st-radius-lg);
  overflow: hidden;
}

.consultor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  background: var(--st-canvas);
  cursor: pointer;
}

.consultor-name {
  font-size: 16px;
  font-weight: 700;
}

.consultor-subtitle {
  font-size: 12px;
  color: var(--st-text-muted);
}

.consultor-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
}

.summary-box {
  background: var(--st-canvas);
  border-radius: var(--st-radius-lg);
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.request-box,
.request-status {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.request-text,
.request-help {
  font-size: 12px;
  color: var(--st-text-muted);
}

.request-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

@media (max-width: 1024.98px) {
  .finance-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .consultor-summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 575px) {
  .finance-grid,
  .consultor-summary-grid {
    grid-template-columns: 1fr;
  }

  .consultor-header {
    flex-direction: column;
    align-items: stretch;
  }

  .consultor-header .btn {
    width: 100%;
  }
}

/* Badges de status da nota fiscal.
   Fundo claro + texto escuro, todos acima de 7:1 — antes eram texto branco
   sobre fundo saturado aplicado por :style (2,63:1 no pendente). As cores
   vem dos tokens --st-status-*, os mesmos usados nas telas mes*.vue. */
.badge[class*="nf-status-"] {
  font-weight: 600;
  border: 1px solid transparent;
}
.nf-status-pending {
  background-color: var(--st-status-pending-bg);
  border-color: var(--st-status-pending-border);
  color: var(--st-status-pending-text);
}
.nf-status-approved {
  background-color: var(--st-status-approved-bg);
  border-color: var(--st-status-approved-border);
  color: var(--st-status-approved-text);
}
.nf-status-rejected {
  background-color: var(--st-status-rejected-bg);
  border-color: var(--st-status-rejected-border);
  color: var(--st-status-rejected-text);
}
.nf-status-returned {
  background-color: var(--st-status-returned-bg);
  border-color: var(--st-status-returned-border);
  color: var(--st-status-returned-text);
}
.nf-status-neutral {
  background-color: var(--st-canvas);
  border-color: var(--st-border);
  color: var(--st-text-muted);
}
</style>
